import React from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";

const ComboTermHour = ({
                         propLabel = '통계주기',
                         propOnChange = null,
                       }) => {
  return (
      <Form.Group as={Row} controlId="formBasicSelectMenu">
        <Form.Label
            className={`col-form-label label text-end`}
            style={{width: "100px"}}
        >
          {propLabel}
        </Form.Label>
        <Col>
          <Form.Select
              aria-label="Default select example"
              className={"input-select"}
              onChange={propOnChange}
          >
            <option value={"H"}>시간</option>
            <option value={"D"}>일간</option>
          </Form.Select>
        </Col>
      </Form.Group>
  );
};

export default ComboTermHour;
